export interface IUserInfo {
	id: string;
	email: string;
	firstname: string;
	lastname: string;
	phone: string;
	department: string;
}

export interface IFormError {
	message?: string;
	key: 'responsible' | 'reporter' | 'description' | 'affectedPersons' | 'affectedData' | 'recognition' | 'occurrence';
}

export class UserInfo {
	static empty = (): IUserInfo => {
		return {
			id: '',
			email: '',
			firstname: '',
			lastname: '',
			phone: '',
			department: '',
		};
	};
	static parse = (data: any): IUserInfo => {
		return {
			id: data.id,
			email: data.email,
			firstname: data.firstname,
			lastname: data.lastname,
			phone: data.phone,
			department: data.department,
		};
	};
}

export interface IFormData {
	responsibleAhks: string[];
	userInfo: IUserInfo;
}

export class FormData {
	static empty = (): IFormData => {
		return {
			responsibleAhks: [],
			userInfo: {
				id: '',
				email: '',
				firstname: '',
				lastname: '',
				phone: '',
				department: '',
			},
		};
	};
	static parse = (data: any): IFormData => {
		return {
			responsibleAhks: data.responsibleAhks,
			userInfo: UserInfo.parse(data.userInfo),
		};
	};
}
